// TT Connect packages
export const ttConnectPackages = [
  {
    ID: 22559884,
    Title: "TTConnect 30/30Mbps FTTH - TTC By Wondernet",
    Price: 799.00,
    "Download speed (kbps)": 30720,
    "Upload speed (kbps)": 30720,
    Supplier: "TT Connect",
    ISP: "Wondernet"
  },
  {
    ID: 22559885,
    Title: "TTConnect 50/50Mbps FTTH - TTC By Wondernet",
    Price: 899.00,
    "Download speed (kbps)": 51200,
    "Upload speed (kbps)": 51200,
    Supplier: "TT Connect",
    ISP: "Wondernet"
  },
  {
    ID: 22559886,
    Title: "TTConnect 100/100Mbps FTTH - TTC By Wondernet",
    Price: 999.00,
    "Download speed (kbps)": 102400,
    "Upload speed (kbps)": 102400,
    Supplier: "TT Connect",
    ISP: "Wondernet"
  },
  {
    ID: 22559887,
    Title: "TTConnect 300/300Mbps FTTH - TTC By Wondernet",
    Price: 1499.00,
    "Download speed (kbps)": 307200,
    "Upload speed (kbps)": 307200,
    Supplier: "TT Connect",
    ISP: "Wondernet"
  }
];